export const ICP_LEDGER = 'ryjl3-tyaaa-aaaaa-aaaba-cai'
export const CKBTC_LEDGER = 'mxzaz-hqaaa-aaaar-qaada-cai'
export const CKBTC_MINTER_CANISTER_ID = 'mqygn-kiaaa-aaaar-qaadq-cai'
export const DEFI_AGGREGATOR_CANISTER_ID = 'u45jl-liaaa-aaaam-abppa-cai'
export const CKETH_MINTER_CANISTER_ID = 'sv3dd-oaaaa-aaaar-qacoa-cai'
export const CKETH_LEDGER_CANISTER_ID = 'ss2fx-dyaaa-aaaar-qacoq-cai'
export const XTC_CANISTER_ID = 'aanaa-xaaaa-aaaah-aaeiq-cai'
export const CKUSDC_LEDGER_CANISTER_ID = 'xevnm-gaaaa-aaaar-qafnq-cai'
export const CKUSDT_LEDGER_CANISTER_ID = 'cngnf-vqaaa-aaaar-qag4q-cai'
export const SEPOLIA_CK_MINTER_CANISTER_ID = 'jzenf-aiaaa-aaaar-qaa7q-cai'
export const CK_MINTER_CANISTER_ID = 'sv3dd-oaaaa-aaaar-qacoa-cai'
export const CYCLES_MINTER_CANISTER_ID = 'rkp4c-7iaaa-aaaaa-aaaca-cai'
export const TCYCLES_CANISTER_ID = 'um5iw-rqaaa-aaaaq-qaaba-cai'
export const ODIN_BACKEND_CANISTER = 'ztwhb-qiaaa-aaaaj-azw7a-cai'
export const PLUG_REGISTRY_CANISTER_ID = 'oelxy-yqaaa-aaaap-qp2oa-cai'
export const YUSAN_CANISTER_ID = '52mp3-qiaaa-aaaar-qbzja-cai'
